<script>
    import Header from "../components/Header.svelte";
    import LearnMore from "../components/LearnMore.svelte";
    import InputBox from "../components/InputBox.svelte";
    import WhiteButton from "../components/WhiteButton.svelte";
    import {writable} from "svelte/store"
    import {onMount} from "svelte";
    import CopyService from "../services/CopyService";
    import QRLinkSvg from "../svg/QRLinkSvg.svelte";
    import RedoSvg from "../svg/RedoSvg.svelte";
    import QrCode from "svelte-qrcode";
    import Hoverable from "../components/Hoverable.svelte";
    import UrlLinkSvg from "../svg/UrlLinkSvg.svelte";

    export let params = {};
    let linkStore = writable(null);
    onMount(() => $linkStore = `${window.location.protocol}//${window.location.host}/#/r/${params.token}/${params.secret}`);

    const copyInputId = 'copy-input';

    let isLinkView = true;

    function copy() {
        CopyService.copy(copyInputId)
    }

    function toggleLinkView() {
        isLinkView = !isLinkView;
    }

</script>

<style>
    section {
        padding: 20px
    }

    .link-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 24px;
    }

    .link-item-container {
        margin-top: 24px;
        display: flex;
        flex-direction: row;
    }

    .link {
        display: flex;
        align-items: center;
        margin-top: 8px;
    }

    .qrcode-wrapper {
        margin-top: 12px;
        padding: 12px;
        background: #F28850;
        height: auto;
        width: auto;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 12px;
        opacity: 0.9;
        border: 1px solid white;
    }
</style>

<section>
    <Header>Your burn link has been generated</Header>
    <LearnMore disableLink={true}>Your message has been encrypted and saved. Only someone with this link can decrypt and
        view it. Once the message has been viewed it will self-destruct.
    </LearnMore>
    <div class="link-container">
        <h2>Your burn link</h2>

        {#if isLinkView}
            <InputBox inputId={copyInputId} store={linkStore} readOnly={true}/>
        {/if}

        {#if !isLinkView}
            <div class="qrcode-wrapper" style="padding: 12px; background: white;">
                <QrCode value={$linkStore} padding="1" background="#FFFFFF" color="#000000" errorCorrection="L"/>
            </div>
        {/if}

        {#if isLinkView}
            <WhiteButton floatText="Copied" click={copy}>Copy Burn Link</WhiteButton>
        {/if}

        <div class="link-item-container">


                {#if isLinkView}
                    <Hoverable let:hovering={active}>
                        <a class="link" on:click={toggleLinkView}> <QRLinkSvg hovered={active}/> <span style="margin-left: 8px;">Show QR Code</span></a>
                    </Hoverable>
                {/if}
                {#if !isLinkView}
                    <Hoverable let:hovering={active}>
                        <a class="link" on:click={toggleLinkView}> <UrlLinkSvg hovered={active}/> <span style="margin-left: 8px;">Show link</span></a>
                    </Hoverable>
                {/if}

                <Hoverable let:hovering={active}>
                    <a class="link" href="/"><RedoSvg hovered={active}/><span style="margin-left: 8px;">Send Another</span></a>
                </Hoverable>


        </div>
    </div>
</section>
